var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "afr-info", attrs: { id: "tab-afr" } },
    [
      _vm.showCodeSearch
        ? _c("div", { staticClass: "section operations" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.cooperateEdit,
                    expression: "cooperateEdit"
                  }
                ],
                staticClass: "triggers"
              },
              [
                _c(
                  "div",
                  [
                    _c(
                      "el-dropdown",
                      {
                        class: _vm.readonly ? "not-click" : "",
                        staticStyle: { "padding-left": "5px" },
                        attrs: { "split-button": "", type: "primary", no: "1" },
                        on: {
                          click: function($event) {
                            return _vm.commandHandle(_vm.command1)
                          },
                          command: function(p) {
                            _vm.command1 = p
                            _vm.commandHandle(_vm.command1)
                          }
                        }
                      },
                      [
                        _vm._v(
                          " " + _vm._s(this.getItemTitle(_vm.command1)) + " "
                        ),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "Copy Last Time",
                                  title: _vm.$t("SeaExport.CopyLast")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(this.getItemTitle("Copy Last Time"))
                                )
                              ]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "Copy By File NO",
                                  title: _vm.$t("SeaExport.WaybillNumberCopy")
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(this.getItemTitle("Copy By File NO"))
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm.isJs
                      ? _c(
                          "el-radio-group",
                          {
                            staticStyle: { "margin-left": "20px" },
                            model: {
                              value: _vm.saveAs,
                              callback: function($$v) {
                                _vm.saveAs = $$v
                              },
                              expression: "saveAs"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.CargoWare")))
                            ]),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v(_vm._s(_vm.$t("SeaExport.Other")))
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _c("div", { staticStyle: { width: "fit-content" } }, [
        _c(
          "div",
          { staticStyle: { display: "flex" } },
          [
            _c("afr-address-format-form", {
              attrs: {
                job: _vm.job,
                "show-second-notify-party": _vm.showSecondNotifyParty,
                readonly: _vm.readonly,
                "local-data": _vm.localData,
                "address-form": _vm.form.afrAddress[0] || {},
                "tab-name": _vm.tabName,
                "is-js": _vm.isJs,
                "js-send-hide": _vm.jsSendHide
              },
              on: {
                showSenderAndReceiverDialog: _vm.showSenderAndReceiverDialog,
                selectionItemHandlerByType: function(p) {
                  _vm.pm.selectionItemHandlerByType(p)
                }
              }
            }),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "112px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: { title: _vm.$t("SeaExport.CargoInformation") }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Cargo Information")))]
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("hblNbr2"),
                        attrs: {
                          label: _vm.getItemTitle("HB/L NO"),
                          title: _vm.$t("SeaExport.HBLNumber")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "2" },
                          on: { input: _vm.hblNbr2Change },
                          model: {
                            value: _vm.form.hblNbr2,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "hblNbr2", $$v)
                            },
                            expression: "form.hblNbr2"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("quantity"),
                        attrs: {
                          title: _vm.$t("SeaExport.BillOfLadingQuantity"),
                          label: _vm.getItemTitle("Quantity")
                        }
                      },
                      [
                        _c("auto-number-input", {
                          attrs: { no: "3", precision: 0, min: 0 },
                          model: {
                            value: _vm.form.quantity,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "quantity", $$v)
                            },
                            expression: "form.quantity"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("packing"),
                        attrs: {
                          title: _vm.$t("SeaExport.Packing"),
                          label: _vm.getItemTitle("Unit Type")
                        }
                      },
                      [
                        _c(
                          "span",
                          { attrs: { slot: "label" }, slot: "label" },
                          [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: _vm.$t(
                                    "CargoMsg.Cargo_AmsUnitTypeTip"
                                  ),
                                  placement: "right-end"
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-question",
                                  staticStyle: {
                                    cursor: "pointer",
                                    color: "#1F75D5"
                                  }
                                })
                              ]
                            ),
                            _vm._v(
                              " " + _vm._s(_vm.getItemTitle("Unit Type")) + " "
                            )
                          ],
                          1
                        ),
                        !_vm.jsSendHide
                          ? _c("cargo-packing-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "default-value": _vm.form.packing,
                                no: "4"
                              },
                              on: { change: _vm.changeUnitType }
                            })
                          : _c("cargo-advance-select", {
                              attrs: {
                                no: "4",
                                "static-options": _vm.localData.jsAfrPacking,
                                "custom-label": function(item) {
                                  return "[" + item.code + "]" + item.name
                                },
                                cache: false,
                                filterable: "",
                                "default-value": _vm.form.packing || "",
                                "filter-tag-names": ["name", "code"],
                                "tag-name": "name",
                                "tag-value": "code"
                              },
                              on: { parentCallBack: _vm.changeUnitType }
                            })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          title: _vm.$t("SeaExport.GrossWeight"),
                          label: _vm.getItemTitle("Gross Weight")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            !_vm.jsSendHide
                              ? _c("el-input-number", {
                                  class: _vm.isDifferent("weight"),
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    precision: 3,
                                    controls: false,
                                    no: "5"
                                  },
                                  model: {
                                    value: _vm.form.weight,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "weight", $$v)
                                    },
                                    expression: "form.weight"
                                  }
                                })
                              : _c("el-input-number", {
                                  class: _vm.isDifferent("weight"),
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    precision: 3,
                                    controls: false,
                                    max: 999999.999,
                                    no: "5"
                                  },
                                  model: {
                                    value: _vm.form.weight,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "weight", $$v)
                                    },
                                    expression: "form.weight"
                                  }
                                }),
                            _c("span", [_vm._v("KGS")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          title: _vm.$t("SeaExport.Cubage"),
                          label: _vm.getItemTitle("Volume")
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            !_vm.jsSendHide
                              ? _c("el-input-number", {
                                  class: _vm.isDifferent("cubage"),
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    precision: 3,
                                    controls: false,
                                    no: "6"
                                  },
                                  model: {
                                    value: _vm.form.cubage,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "cubage", $$v)
                                    },
                                    expression: "form.cubage"
                                  }
                                })
                              : _c("el-input-number", {
                                  class: _vm.isDifferent("cubage"),
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    precision: 3,
                                    controls: false,
                                    no: "6",
                                    max: 999999.999
                                  },
                                  model: {
                                    value: _vm.form.cubage,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "cubage", $$v)
                                    },
                                    expression: "form.cubage"
                                  }
                                }),
                            _c("span", [_vm._v("CBM")])
                          ],
                          1
                        )
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "HS CODE" } },
                      [
                        _c("el-input", {
                          attrs: { no: "7" },
                          on: { change: _vm.hsCodeInputChanged },
                          model: {
                            value: _vm.form.hsCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "hsCode", $$v)
                            },
                            expression: "form.hsCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("County of Origin"),
                          title: _vm.$t("SeaExport.CountryOfOrigin")
                        }
                      },
                      [
                        !_vm.jsSendHide
                          ? _c("cargo-advance-select", {
                              attrs: {
                                no: "countryOrigin",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Country,
                                "tag-name": "code",
                                filterable: "",
                                "default-value": _vm.form.countryOrigin
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.countryOrigin = p.value
                                  _vm.setNameOfCountry(p)
                                }
                              }
                            })
                          : _c("cargo-advance-select", {
                              attrs: {
                                no: "countryOrigin",
                                "static-options": _vm.localData.jsCountry,
                                cache: false,
                                "default-value": _vm.form.countryOrigin,
                                filterable: "",
                                clearable: "",
                                "filter-tag-names": ["code"],
                                "tag-name": "code",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.countryOrigin = p.value
                                  _vm.localData.nameOfCountry = p.name
                                }
                              }
                            }),
                        _c("el-input", {
                          model: {
                            value: _vm.localData.nameOfCountry,
                            callback: function($$v) {
                              _vm.$set(_vm.localData, "nameOfCountry", $$v)
                            },
                            expression: "localData.nameOfCountry"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.jsSendHide,
                            expression: "!jsSendHide"
                          }
                        ],
                        attrs: { label: _vm.getItemTitle("Deliv.Mode") }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "freightTerm",
                            filterable: "",
                            "default-value": _vm.form.freightTermHBL,
                            cache: false,
                            "tag-name": "chineseName",
                            "tag-value": "code",
                            "filter-tag-names": ["code", "chineseName"],
                            "static-options":
                              _vm.SystemConstants.AMS_FREIGHT_TERM
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.freightTermHBL = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Place of Receipt"),
                          title: _vm.$t("SeaExport.BillLadingPlaceOfDispatch")
                        }
                      },
                      [
                        !_vm.jsSendHide
                          ? _c("cargo-advance-select", {
                              staticStyle: { flex: "1" },
                              attrs: {
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Seaport,
                                filterable: "",
                                "default-value": _vm.form.dispatchingPlaceCode,
                                "tag-name": "englishName",
                                no: "8"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange(
                                    p,
                                    "dispatchingPlaceCode",
                                    "dispatchingPlace"
                                  )
                                }
                              }
                            })
                          : _c("cargo-advance-select", {
                              attrs: {
                                no: "8",
                                "static-options": _vm.localData.jsAfrPortList,
                                "custom-label": function(item) {
                                  return "[" + item.code + "]" + item.name
                                },
                                cache: false,
                                filterable: "",
                                "default-value":
                                  _vm.form.dispatchingPlaceCode || "",
                                "filter-tag-names": ["name", "code"],
                                "tag-name": "name",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange2(
                                    p,
                                    "dispatchingPlaceCode",
                                    "dispatchingPlace"
                                  )
                                }
                              }
                            }),
                        _c("el-input", {
                          model: {
                            value: _vm.form.dispatchingPlace,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dispatchingPlace", $$v)
                            },
                            expression: "form.dispatchingPlace"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("destinationPortCode"),
                        attrs: {
                          label: _vm.getItemTitle("Place of Delivery"),
                          title: _vm.$t("SeaExport.BillLadingPlaceOfDelivery")
                        }
                      },
                      [
                        !_vm.jsSendHide
                          ? _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Seaport,
                                filterable: "",
                                "default-value":
                                  _vm.form.destinationPortCode || "",
                                "tag-name": "englishName",
                                no: "9"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange(
                                    p,
                                    "destinationPortCode",
                                    "destinationPort"
                                  )
                                }
                              }
                            })
                          : _c("cargo-advance-select", {
                              attrs: {
                                no: "23",
                                "static-options": _vm.localData.jsAfrPortList,
                                "custom-label": function(item) {
                                  return "[" + item.code + "]" + item.name
                                },
                                cache: false,
                                filterable: "",
                                "default-value":
                                  _vm.form.destinationPortCode || "",
                                "filter-tag-names": ["name", "code"],
                                "tag-name": "name",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange2(
                                    p,
                                    "destinationPortCode",
                                    "destinationPort"
                                  )
                                }
                              }
                            }),
                        _c("el-input", {
                          model: {
                            value: _vm.form.destinationPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "destinationPort", $$v)
                            },
                            expression: "form.destinationPort"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.jsSendHide
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.getItemTitle("Cargo Type") } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { no: "50" },
                                model: {
                                  value: _vm.form.goodsType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "goodsType", $$v)
                                  },
                                  expression: "form.goodsType"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "General Cargo", value: 0 }
                                }),
                                _c("el-option", {
                                  attrs: { label: "Dangerous Cargo", value: 1 }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.jsSendHide && _vm.isDangerousCargo
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              title: "Hazardous code",
                              label: _vm.getItemTitle("Hazardous code")
                            }
                          },
                          [
                            _vm.jsSendHide
                              ? _c("cargo-advance-select", {
                                  attrs: {
                                    no: "51",
                                    "static-options":
                                      _vm.localData.jsAfrDangerous,
                                    cache: false,
                                    filterable: "",
                                    "default-value":
                                      _vm.form.hazardousCode || "",
                                    "filter-tag-names": ["code"],
                                    "tag-name": "code",
                                    "tag-value": "code"
                                  },
                                  on: {
                                    parentCallBack: function(p) {
                                      _vm.form.hazardousCode = p.value
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.jsSendHide && _vm.isDangerousCargo
                      ? _c(
                          "el-form-item",
                          { attrs: { label: _vm.getItemTitle("IMDG Class") } },
                          [
                            _c("el-input", {
                              attrs: { no: "52" },
                              model: {
                                value: _vm.form.imdgClass,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "imdgClass", $$v)
                                },
                                expression: "form.imdgClass"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.jsSendHide && _vm.isDangerousCargo
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "UN No." } },
                          [
                            _c("el-input", {
                              attrs: { no: "53" },
                              model: {
                                value: _vm.form.unNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "unNo", $$v)
                                },
                                expression: "form.unNo"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.jsSendHide
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              "label-width": "0",
                              title: _vm.$t("SeaExport.EnglishCommodityName")
                            }
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.getItemTitle("Commodity Decription"))
                              )
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm.jsSendHide
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { "label-width": "0" }
                          },
                          [
                            _c("cargo-rich-textarea", {
                              class: _vm.isDifferent("cargoEnglishName"),
                              staticStyle: { height: "110px" },
                              attrs: {
                                disabled: !_vm.isEdit,
                                "text-chars": 0,
                                "wrap-symbol": "r",
                                "auto-uppercase": "",
                                "auto-half-word": "",
                                "warning-count": -1,
                                no: "9"
                              },
                              model: {
                                value: _vm.form.cargoEnglishName,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "cargoEnglishName", $$v)
                                },
                                expression: "form.cargoEnglishName"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.jsSendHide
                      ? _c("el-form-item", { attrs: { "label-width": "0" } }, [
                          _c("span", [
                            _vm._v(_vm._s(_vm.getItemTitle("Marks")))
                          ])
                        ])
                      : _vm._e(),
                    _vm.jsSendHide
                      ? _c(
                          "el-form-item",
                          {
                            staticClass: "auto-width",
                            attrs: { "label-width": "0" }
                          },
                          [
                            _c("cargo-rich-textarea", {
                              attrs: {
                                "text-chars": 0,
                                maxlength: 300,
                                disabled: !_vm.isEdit,
                                type: "textarea",
                                rows: 5,
                                no: "55"
                              },
                              model: {
                                value: _vm.form.mark,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "mark", $$v)
                                },
                                expression: "form.mark"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.jsSendHide,
                            expression: "!jsSendHide"
                          }
                        ],
                        attrs: {
                          "label-width": "0",
                          title: _vm.$t("SeaExport.Remarks")
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.getItemTitle("Remark (max 300 letters)"))
                          )
                        ])
                      ]
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.jsSendHide,
                            expression: "!jsSendHide"
                          }
                        ],
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            maxlength: 300,
                            disabled: !_vm.isEdit,
                            type: "textarea",
                            rows: 5,
                            no: "10"
                          },
                          model: {
                            value: _vm.form.remarks,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "remarks", $$v)
                            },
                            expression: "form.remarks"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "116px",
                      "label-position": "right"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: {
                          title: _vm.$t("SeaExport.TransportationInformation")
                        }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Shipping Information")))]
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { "label-width": "0" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              title: _vm.$t("SeaExport.SynchroniseBooking"),
                              no: "11"
                            },
                            on: {
                              click: function($event) {
                                return _vm.pm.onSyncBooking()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.getItemTitle("Synchronise Booking"))
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("mbl"),
                        attrs: {
                          label: _vm.getItemTitle("MB/L NO"),
                          title: _vm.$t("SeaExport.MBLNumber")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "12" },
                          on: {
                            change: function($event) {
                              return _vm.pm.syncAfrInfo("mbl")
                            }
                          },
                          model: {
                            value: _vm.form.mbl,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "mbl", $$v)
                            },
                            expression: "form.mbl"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("vessel"),
                        attrs: {
                          label: _vm.getItemTitle("Vessel"),
                          title: _vm.$t("SeaExport.ShipName")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "13" },
                          on: {
                            change: function($event) {
                              return _vm.pm.syncAfrInfo("vessel")
                            }
                          },
                          model: {
                            value: _vm.form.vessel,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "vessel", $$v)
                            },
                            expression: "form.vessel"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.jsSendHide,
                            expression: "jsSendHide"
                          }
                        ],
                        class: _vm.isDifferent("Vessel Code"),
                        attrs: { label: _vm.getItemTitle("Vessel Code") }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "57" },
                          on: {
                            change: function($event) {
                              return _vm.pm.syncAfrInfo("vesselCode")
                            }
                          },
                          model: {
                            value: _vm.form.vesselCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "vesselCode", $$v)
                            },
                            expression: "form.vesselCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("voyageFlight"),
                        attrs: {
                          label: _vm.getItemTitle("Voyage"),
                          title: _vm.$t("SeaExport.Voyage")
                        }
                      },
                      [
                        _c("cargo-rich-textarea", {
                          staticStyle: { "min-height": "unset" },
                          attrs: {
                            disabled: _vm.readonly,
                            "text-chars": 0,
                            "warning-count": 10,
                            "is-trim": true,
                            no: "14"
                          },
                          on: { change: _vm.changeVoyage },
                          model: {
                            value: _vm.form.voyageFlight,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "voyageFlight", $$v)
                            },
                            expression: "form.voyageFlight"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.jsSendHide,
                            expression: "jsSendHide"
                          }
                        ],
                        attrs: {
                          label: _vm.getItemTitle("Vessel country flag")
                        }
                      },
                      [
                        _c("cargo-advance-select", {
                          attrs: {
                            no: "54",
                            "select-type": _vm.TYPE_NAMES.basic_data_Country,
                            cache: false,
                            filterable: "",
                            "default-value": _vm.form.nationalityCodeofVessel,
                            "filter-tag-names": ["code", "chineseName", "name"],
                            "tag-name": "code",
                            "tag-value": "code"
                          },
                          on: {
                            parentCallBack: function(p) {
                              _vm.form.nationalityCodeofVessel = p.value
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.jsSendHide,
                            expression: "!jsSendHide"
                          }
                        ],
                        class: _vm.isDifferent("vesselIMO"),
                        attrs: {
                          label: _vm.getItemTitle("IMO"),
                          title: _vm.$t("SeaExport.ShipNumber")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "15" },
                          on: {
                            change: function($event) {
                              return _vm.pm.syncAfrInfo("vesselIMO")
                            }
                          },
                          model: {
                            value: _vm.form.vesselIMO,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "vesselIMO", $$v)
                            },
                            expression: "form.vesselIMO"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.jsSendHide,
                            expression: "!jsSendHide"
                          }
                        ],
                        class: _vm.isDifferent("vesselCode"),
                        attrs: {
                          label: _vm.getItemTitle("Call Sign"),
                          title: _vm.$t("SeaExport.BookingShipCallSign")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { no: "16" },
                          on: {
                            change: function($event) {
                              return _vm.pm.syncAfrInfo("vesselCode")
                            }
                          },
                          model: {
                            value: _vm.form.vesselCode,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "vesselCode", $$v)
                            },
                            expression: "form.vesselCode"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("etd"),
                        attrs: {
                          label: _vm.getItemTitle("ETD"),
                          title: _vm.$t("SeaExport.DateOfDeparture")
                        }
                      },
                      [
                        _vm.jsSendHide
                          ? _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "datetime",
                                "value-format": "yyyy-MM-dd HH:mm",
                                no: "17"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.pm.syncAfrInfo("etd")
                                }
                              },
                              model: {
                                value: _vm.form.etd,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "etd", $$v)
                                },
                                expression: "form.etd"
                              }
                            })
                          : _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "date",
                                "value-format": "yyyy-MM-dd",
                                no: "17"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.pm.syncAfrInfo("etd")
                                }
                              },
                              model: {
                                value: _vm.form.etd,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "etd", $$v)
                                },
                                expression: "form.etd"
                              }
                            })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("eta"),
                        attrs: {
                          label: _vm.getItemTitle("ETA"),
                          title: _vm.$t("SeaExport.ArrivalDate")
                        }
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            type: "date",
                            "value-format": "yyyy-MM-dd",
                            no: "18"
                          },
                          on: {
                            change: function($event) {
                              return _vm.pm.syncAfrInfo("eta")
                            }
                          },
                          model: {
                            value: _vm.form.eta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "eta", $$v)
                            },
                            expression: "form.eta"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("loadingPortCode"),
                        attrs: {
                          label: _vm.getItemTitle("Place of Loading"),
                          title: _vm.$t("SeaExport.BillLadingPortOfDeparture")
                        }
                      },
                      [
                        !_vm.jsSendHide
                          ? _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Seaport,
                                filterable: "",
                                "default-value": _vm.form.loadingPortCode || "",
                                "tag-name": "englishName",
                                no: "19"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange(
                                    p,
                                    "loadingPortCode",
                                    "loadingPort"
                                  )
                                }
                              }
                            })
                          : _c("cargo-advance-select", {
                              attrs: {
                                no: "23",
                                "static-options": _vm.localData.jsAfrPortList,
                                "custom-label": function(item) {
                                  return "[" + item.code + "]" + item.name
                                },
                                cache: false,
                                filterable: "",
                                "default-value": _vm.form.loadingPortCode || "",
                                "filter-tag-names": ["name", "code"],
                                "tag-name": "name",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange2(
                                    p,
                                    "loadingPortCode",
                                    "loadingPort"
                                  )
                                }
                              }
                            }),
                        _c("el-input", {
                          model: {
                            value: _vm.form.loadingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "loadingPort", $$v)
                            },
                            expression: "form.loadingPort"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        class: _vm.isDifferent("dischargingPortCode"),
                        attrs: {
                          label: _vm.getItemTitle("Place of Discharge"),
                          title: _vm.$t("SeaExport.BillLadingPortOfDischarge")
                        }
                      },
                      [
                        !_vm.jsSendHide
                          ? _c("cargo-advance-select", {
                              attrs: {
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Seaport,
                                filterable: "",
                                "default-value":
                                  _vm.form.dischargingPortCode || "",
                                "tag-name": "englishName",
                                no: "20"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange(
                                    p,
                                    "dischargingPortCode",
                                    "dischargingPort"
                                  )
                                }
                              }
                            })
                          : _c("cargo-advance-select", {
                              attrs: {
                                no: "23",
                                "static-options": _vm.localData.jsAfrPortList,
                                "custom-label": function(item) {
                                  return "[" + item.code + "]" + item.name
                                },
                                cache: false,
                                filterable: "",
                                "default-value":
                                  _vm.form.dischargingPortCode || "",
                                "filter-tag-names": ["name", "code"],
                                "tag-name": "name",
                                "tag-value": "code"
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.portChange2(
                                    p,
                                    "dischargingPortCode",
                                    "dischargingPort"
                                  )
                                }
                              }
                            }),
                        _c("el-input", {
                          attrs: { no: "21" },
                          model: {
                            value: _vm.form.dischargingPort,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "dischargingPort", $$v)
                            },
                            expression: "form.dischargingPort"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "section form-column" },
              [
                _c(
                  "el-form",
                  {
                    staticStyle: { height: "100%" },
                    attrs: {
                      disabled: _vm.readonly,
                      "label-width": "100px",
                      "label-position": "left"
                    }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "title",
                        attrs: { title: _vm.$t("SeaExport.OtherInformation") }
                      },
                      [_vm._v(_vm._s(_vm.getItemTitle("Other")))]
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.jsSendHide,
                            expression: "!jsSendHide"
                          }
                        ],
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "200px" },
                          attrs: {
                            "grid-options": _vm.masterInfo.gridOptions,
                            "column-defs": _vm.masterInfoColumnDefs,
                            "row-data": _vm.masterInfo.rowData
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.masterInfo.gridApi = params.api
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "auto-width",
                        attrs: { "label-width": "0" }
                      },
                      [
                        _c("cargo-ag-grid", {
                          staticStyle: { width: "100%", height: "200px" },
                          attrs: {
                            "grid-options": _vm.afr2.gridOptions,
                            "column-defs": _vm.afr2ColumnDefs,
                            "row-data": _vm.afr2.rowData
                          },
                          on: {
                            gridReady: function(params) {
                              _vm.afr2.gridApi = params.api
                            }
                          }
                        }),
                        _c("div", { staticStyle: { padding: "5px 0" } }, [
                          _c(
                            "div",
                            { staticStyle: { float: "right" } },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    title: _vm.$t("SeaExport.Add2"),
                                    no: "22"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onAddNewAfrCargoDoc()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("Add")))]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    title: _vm.$t(
                                      "SeaExport.SynchronizeHBLInformation"
                                    ),
                                    no: "23"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.btnSynchroAfrClickHandler()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.getItemTitle("Synchronise HB/L"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "danger",
                                    title: _vm.$t("SeaExport.Delete"),
                                    no: "24"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pm.onRemoveCargoDoc()
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.getItemTitle("Carrier SCAC"),
                          title: _vm.$t("SeaExport.ShippingCompanySCAC")
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            disabled: true,
                            value: _vm.localData.afrCarrierScAc,
                            no: "25"
                          }
                        })
                      ],
                      1
                    ),
                    _vm.jsSendHide
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.getItemTitle("Nvocc SCAC"),
                              title: _vm.$t("SeaExport.NonVesselCarrierSCAC")
                            }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: {
                                  filterable: "",
                                  "allow-create": true,
                                  no: "37"
                                },
                                model: {
                                  value: _vm.form.nvoccScac,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "nvoccScac", $$v)
                                  },
                                  expression: "form.nvoccScac"
                                }
                              },
                              _vm._l(_vm.localData.nvoccScacList, function(
                                item
                              ) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.jsSendHide
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.getItemTitle("Destination Agent"),
                              title: _vm.$t("SeaExport.DestinationAgent")
                            }
                          },
                          [
                            _c("cargo-advance-select", {
                              attrs: {
                                no: "destinationAgentDoc",
                                "select-type":
                                  _vm.TYPE_NAMES.basic_data_Company,
                                filterable: "",
                                "method-params": {
                                  overseaAgent: true,
                                  active: true
                                },
                                "default-value":
                                  _vm.form.destinationAgentDoc || "",
                                placeholder: " "
                              },
                              on: {
                                parentCallBack: function(p) {
                                  _vm.form.destinationAgentDoc = p.value
                                  _vm.pm.syncAfrInfo("destinationAgentDoc")
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.jsSendHide,
                            expression: "!jsSendHide"
                          }
                        ]
                      },
                      [
                        _c(
                          "span",
                          {
                            attrs: {
                              title: _vm.$t("SeaExport.DeclarationType")
                            }
                          },
                          [_vm._v(_vm._s(_vm.getItemTitle("Declare Type")))]
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticStyle: { "margin-top": "5px" },
                            attrs: { "label-width": "0" }
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { no: "26" },
                                on: {
                                  change: function($event) {
                                    return _vm.pm.syncAfrInfo("frob")
                                  }
                                },
                                model: {
                                  value: _vm.form.frob,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "frob", $$v)
                                  },
                                  expression: "form.frob"
                                }
                              },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      content:
                                        _vm.tabName === "ams"
                                          ? _vm.$t(
                                              "SeaExport.DirectToTheUnitedStates"
                                            )
                                          : _vm.$t("SeaExport.DirectToCanada"),
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "I",
                                          value: "I"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.getItemTitle("Import"))
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    staticStyle: { display: "block" },
                                    attrs: {
                                      effect: "dark",
                                      content: _vm.$t(
                                        "SeaExport.CargoThroughTheUnitedStates"
                                      ),
                                      placement: "right"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      {
                                        attrs: {
                                          disabled: _vm.readonly,
                                          label: "F",
                                          value: "F"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getItemTitle(
                                              "Foreign cargo remaining on-board"
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.jsSendHide,
                            expression: "!jsSendHide"
                          }
                        ],
                        class: _vm.isDifferent("containerLoadType"),
                        attrs: {
                          title: _vm.$t("SeaExport.FLCLType"),
                          label: _vm.getItemTitle("Consignment Type")
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              placeholder: _vm.$t("SeaExport.PleaseChoose"),
                              no: "27"
                            },
                            on: {
                              change: function($event) {
                                return _vm.pm.syncAfrInfo("containerLoadType")
                              }
                            },
                            model: {
                              value: _vm.form.containerLoadType,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "containerLoadType", $$v)
                              },
                              expression: "form.containerLoadType"
                            }
                          },
                          _vm._l(_vm.consignmentTypes, function(item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item, value: item }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm.jsSendHide
                      ? _c(
                          "el-form-item",
                          {
                            attrs: { label: _vm.getItemTitle("Sender Account") }
                          },
                          [
                            _c("el-input", {
                              attrs: { disabled: true, no: "56" },
                              model: {
                                value: _vm.form.reporterID,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "reporterID", $$v)
                                },
                                expression: "form.reporterID"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.tabName !== "isf",
              expression: "tabName !== 'isf'"
            }
          ],
          staticClass: "section"
        },
        [
          _c(
            "span",
            {
              staticClass: "title",
              attrs: { title: _vm.$t("SeaExport.ContainerInformation") }
            },
            [_vm._v(_vm._s(_vm.getItemTitle("House Container Information")))]
          ),
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-direction": "column" } },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  staticStyle: { padding: "5px 0" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        title: _vm.$t("SeaExport.AddContainerInformation"),
                        no: "28"
                      },
                      on: {
                        click: function($event) {
                          _vm.cargoDocUsageSelectedDialog.visible = true
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.getItemTitle("Add")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "danger",
                        title: _vm.$t("SeaExport.RemoveContainerInformation"),
                        no: "29"
                      },
                      on: { click: _vm.removeContainerUsageClickHandler }
                    },
                    [_vm._v(_vm._s(_vm.getItemTitle("Delete")))]
                  )
                ],
                1
              ),
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", height: "350px" },
                attrs: {
                  "config-module": "130901",
                  "grid-options": _vm.container.gridOptions,
                  "column-defs": _vm.containerColumnDefs,
                  "row-data": _vm.containerFinalRowData
                },
                on: {
                  gridReady: function(params) {
                    _vm.container.gridApi = params.api
                  }
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.advanceTextDialog.visible,
            title: _vm.advanceTextDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.advanceTextDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-rich-textarea", {
            ref: "advanceTextDialogTextarea",
            staticStyle: { height: "198px" },
            attrs: {
              no: "30",
              "text-chars": 0,
              "auto-uppercase": _vm.advanceTextDialog.isUppercase,
              "auto-half-word": _vm.advanceTextDialog.formatObj.autoHalfWord,
              "warning-count": 50,
              disabled: _vm.readonly
            },
            model: {
              value: _vm.advanceTextDialog.value,
              callback: function($$v) {
                _vm.$set(_vm.advanceTextDialog, "value", $$v)
              },
              expression: "advanceTextDialog.value"
            }
          }),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEdit,
                      expression: "isEdit"
                    }
                  ],
                  attrs: { type: "primary", no: "31" },
                  on: { click: _vm.finishAdvanceText }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "32" },
                  on: {
                    click: function($event) {
                      _vm.advanceTextDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.receiptInfoDialog.visible,
            title: _vm.receiptInfoDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.receiptInfoDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "350px" },
            attrs: {
              "grid-options": _vm.receiptInfoDialog.gridOptions,
              "column-defs": _vm.receiptInfoDialog.columnDefs,
              "row-data": _vm.receiptInfoDialog.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.receiptInfoDialog.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c("cargo-doc-usage-selected-dialog", {
        attrs: {
          visible: _vm.cargoDocUsageSelectedDialog.visible,
          job: _vm.job,
          "doc-type": _vm.CargoDocConsts.AFR
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cargoDocUsageSelectedDialog, "visible", $event)
          },
          callback: _vm.cargoDocUsageSelectedDialog.callback
        }
      }),
      _c("ams-log-view-title-dialog", {
        attrs: {
          visible: _vm.amsLogViewTitleDialog.visible,
          "row-data": _vm.amsLogViewTitleDialog.rowData
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.amsLogViewTitleDialog, "visible", $event)
          }
        }
      }),
      _c("afr-address-dialog", {
        attrs: {
          visible: _vm.searchBillNoDialog.visible,
          params: _vm.searchBillNoDialog.params,
          "no-label": _vm.amsTitle,
          "no-title": _vm.amsTitleCn
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.searchBillNoDialog, "visible", $event)
          },
          selected: function(p) {
            _vm.pm.selectionItemHandler(p)
          }
        }
      }),
      _c("yf-afr-address-dialog", {
        attrs: {
          visible: _vm.afrSearchBillNoDialog.visible,
          params: _vm.afrSearchBillNoDialog.params,
          "no-label": _vm.amsTitle,
          "no-title": _vm.amsTitleCn
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.afrSearchBillNoDialog, "visible", $event)
          },
          selected: function(p) {
            _vm.pm.selectionItemHandler(p)
          }
        }
      }),
      _c("select-sub-loc-dialog", {
        attrs: {
          visible: _vm.selectSubLocDialog.visible,
          type: _vm.selectSubLocDialog.type
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.selectSubLocDialog, "visible", $event)
          },
          select: _vm.selectSubLocCallBack,
          close: function() {
            return (_vm.selectSubLocDialog.visible = false)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.checkDialog.visible,
            title: _vm.checkDialog.title,
            width: "600px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.checkDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "350px" },
            attrs: {
              "grid-options": _vm.checkDialog.gridOptions,
              "column-defs": _vm.checkDialog.columnDefs,
              "row-data": _vm.checkDialog.rowData,
              "show-side-bar": false
            },
            on: {
              gridReady: function(params) {
                _vm.checkDialog.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.receiptDialog.visible,
            title: _vm.receiptDialog.title,
            width: "1000px",
            "close-on-click-modal": false,
            "close-on-press-escape": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.receiptDialog, "visible", $event)
            }
          }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "350px" },
            attrs: {
              "grid-options": _vm.receiptDialog.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.receiptDialog.rowData,
              "show-side-bar": false
            },
            on: {
              gridReady: function(params) {
                _vm.receiptDialog.gridApi = params.api
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }